import { render, staticRenderFns } from "./PreviewFormsNLCR.vue?vue&type=template&id=90f5e860"
import script from "./PreviewFormsNLCR.vue?vue&type=script&lang=ts"
export * from "./PreviewFormsNLCR.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports